module.exports = __webpack_public_path__ + "static/media/speaker5.4c86ea30.jpg";